/* Article: the thumbnail row under the picture (sections/main-article).
 *
 * Ports live's `article-thumbnails`: pressing a thumbnail shows that image in
 * the main picture's place, or plays that video there with its controls and
 * sound. The first thumbnail is the featured picture, so a reader can always
 * get back. srcset and sizes are dropped before a swap, or the browser keeps
 * drawing the original from its srcset. Guarded, since the section prints its
 * own <script> tag.
 */
(function () {
  if (window.__ddjMainArticle) return;
  window.__ddjMainArticle = true;

  function init(root) {
    var stage = root.querySelector('[data-article-stage]');
    var img = stage && stage.querySelector('[data-article-stage-img]');
    if (!stage || !img || stage.dataset.thumbsReady === 'true') return;
    stage.dataset.thumbsReady = 'true';

    var thumbs = root.querySelectorAll('[data-article-thumb]');
    Array.prototype.forEach.call(thumbs, function (thumb) {
      thumb.addEventListener('click', function () {
        var old = stage.querySelector('video');
        if (old) old.remove();

        if (thumb.dataset.type === 'video') {
          var video = document.createElement('video');
          video.src = thumb.dataset.src;
          video.controls = true;
          video.autoplay = true;
          video.playsInline = true;
          video.className = 'block h-auto w-full bg-black';
          img.hidden = true;
          stage.insertBefore(video, img);
        } else {
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.src = thumb.dataset.src;
          img.hidden = false;
        }

        Array.prototype.forEach.call(thumbs, function (t) {
          t.setAttribute('aria-pressed', t === thumb ? 'true' : 'false');
        });

        var top = stage.getBoundingClientRect().top;
        if (top < 0) {
          window.scrollTo({ top: window.pageYOffset + top - 120, behavior: 'smooth' });
        }
      });
    });
  }

  function initAll(scope) {
    Array.prototype.forEach.call(
      (scope || document).querySelectorAll('[data-main-article]'),
      init
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
